import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";

import "./card_group_extended.scss";

const context = require.context('./', true, /_controller\.js$/);
application.load(definitionsFromContext(context));